import { useState } from "react";
import { ActionsMenu } from "./ActionsMenu";
import { useProposalPdfs } from "../hooks/useProposalPdfs";

export const QuotePdfActions = ({ quote, id, items, ...props }) => {
  const [open, setOpen] = useState(false);
  // Lists can contain hundreds of quotes: fetch/poll only the open menu.
  const pdfs = useProposalPdfs(quote.id, quote.updated_at, open, `${id}-`, quote.public_token);
  return <ActionsMenu id={id} {...props} onOpenChange={setOpen}
    items={[...items.slice(0, 2), ...pdfs.items, ...items.slice(2)]} />;
};